module.exports = __webpack_public_path__ + "static/media/new-santander.dab93bd8.png";